export default __webpack_public_path__ + "files/Roadmap_Southern_Great_Plain_Region.docx";